import React                                from 'react'
import {Box, IconButton, Slide, Snackbar, Typography, useTheme} from '@mui/material'
import {Close}                              from '@mui/icons-material'
import AchievementBadgeIcon                 from './AchievementBadgeIcon'

/*
 * Announces a newly earned badge. One at a time -- the queue lives in useAchievementAlerts,
 * this component only renders whatever is at its head.
 *
 * Driven entirely by props (badge in, onDismiss out) so it can sit on the dashboard and the
 * question screen without either one owning notification state.
 */

const SlideUp = (props) => <Slide {...props} direction="up"/>

const AchievementToast = ({achievement, remaining = 0, onDismiss, autoHideMs = 6000}) => {
	const theme = useTheme()
	const custom = theme.custom

	return (
		<Snackbar
			open={Boolean(achievement)}
			// key on the token so a queued badge re-animates instead of silently swapping text
			key={achievement ? achievement.token : 'none'}
			onClose={(e, reason) => { if (reason !== 'clickaway') onDismiss && onDismiss() }}
			autoHideDuration={autoHideMs}
			TransitionComponent={SlideUp}
			anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
		>
			<Box
				sx={{
					display: 'flex', alignItems: 'center', gap: 1.75,
					px: 2, py: 1.75, minWidth: 300, maxWidth: 420,
					background: custom.bg.surface,
					border: `1px solid ${custom.border.strong}`,
					borderRadius: `${custom.radius.md}px`,
					boxShadow: custom.shadow.pop,
				}}
			>
				{achievement && (
					<AchievementBadgeIcon
						token={achievement.token}
						category={achievement.category}
						size={52}
						title={achievement.name}
					/>
				)}
				<Box sx={{flex: 1, minWidth: 0}}>
					<Typography sx={{
						fontSize: custom.fontSize.xxs,
						fontWeight: custom.fontWeight.semibold,
						textTransform: 'uppercase',
						letterSpacing: .5,
						color: custom.hud.streak,
					}}>
						Badge earned
					</Typography>
					<Typography sx={{fontSize: custom.fontSize.lg, fontWeight: custom.fontWeight.bold, color: custom.text.main}}>
						{achievement && achievement.name}
					</Typography>
					<Typography sx={{fontSize: custom.fontSize.xs, color: custom.text.muted}}>
						{achievement && achievement.description}
					</Typography>
					{remaining > 0 && (
						<Typography sx={{mt: 0.5, fontSize: custom.fontSize.xxs, color: custom.text.subtopic}}>
							+{remaining} more to see
						</Typography>
					)}
				</Box>
				<IconButton size="small" onClick={onDismiss} sx={{color: custom.text.muted, alignSelf: 'flex-start'}}>
					<Close fontSize="small"/>
				</IconButton>
			</Box>
		</Snackbar>
	)
}

export default AchievementToast
